module.exports = __webpack_public_path__ + "static/lascaux_control_02-d80fc7c44ad74ba07505b374e2c31f0f.png";